var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-row',[_c('v-col',{attrs:{"md":"6","sm":"12"}},[_c('Tabs',{attrs:{"tabs":_vm.tabs}})],1)],1),_c('router-view',{key:_vm.$route.path,attrs:{"industry-type":_vm.activeIndustryTypeTab}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }